import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { TagLabel as ZinniaTagLabel } from '@zapier/design-system';
import { RichText } from '../RichText';
export function TagLabel(props) {
    return (_jsx(ZinniaTagLabel, Object.assign({ color: props.color, size: props.size }, { children: _jsx(RichText, { html: props.text }) })));
}
//# sourceMappingURL=TagLabel.js.map